const allAsideNav = [
  {
    path: '/home',
    name: '首頁',
    icon: 'el-icon-location',
    roles: ['admin', 'visitor', 'esg.admin', 'editor']
  }, {
    path: 'mgsys',
    name: '心願認養',
    icon: 'el-icon-star-on',
    roles: ['admin', 'visitor', 'esg.admin'],
    children: [
      {
        path: '/wishMg',
        name: '心願管理',
        roles: ['admin', 'visitor', 'esg.admin']
      },
      {
        path: '/readingMg',
        name: '愛閱分享',
        roles: ['admin', 'visitor']
      },
      {
        path: '/wishConfig',
        name: '心願配置',
        roles: ['admin', 'visitor', 'esg.admin']
      }
    ]
  },
  {
    path: 'auditMg',
    name: '審核管理',
    icon: 'el-icon-service',
    roles: ['admin', 'visitor'],
    children: [
      {
        path: '/changeRoleMg',
        name: '身份轉換'
      }, {
        path: '/realNameMg',
        name: '實名認證'
      }, {
        path: '/reportedGifts',
        name: '被檢舉禮物審核'
      }, {
        path: '/reportedNeeds',
        name: '被檢舉需求審核'
      }, {
        path: '/reportedMoments',
        name: '被檢舉說說審核'
      }, {
        path: '/newconnect',
        name: '交接預告審核'
      }, {
        path: '/applyCancelDeals',
        name: '取消交易申請'
      }, {
        path: '/userMarks',
        name: '黑名單管理'
      }, {
        path: '/giftRatings',
        name: '物況反饋審核'
      }
    ]
  },
  {
    path: 'users',
    name: '使用者管理',
    iconAws: 'user-circle-o',
    roles: ['admin', 'visitor'],
    children: [
      {
        path: '/users',
        name: '使用者列表'
      },
      {
        path: '/userLogins',
        name: '登入記錄'
      },
      {
        path: '/userBonus',
        name: '好人點預警'
      },
      {
        path: '/multipleAccounts',
        name: '分身監控'
      }
    ]
  },
  {
    path: 'gifts',
    name: '禮物管理',
    icon: 'el-icon-goods',
    roles: ['admin', 'visitor'],
    children: [
      {
        path: '/gifts',
        name: '禮物池'
      },
      {
        path: '/giftRecords',
        name: '禮物交易記錄'
      }
    ]
  }, {
    path: 'needs',
    name: '需求管理',
    iconAws: 'shopping-cart',
    roles: ['admin', 'visitor'],
    children: [
      {
        path: '/needsListMg',
        name: '需求池'
      }, {
        path: '/needsRecords',
        name: '需求交易記錄'
      }, {
        path: '/needsSections',
        name: '需求專區管理'
      }
    ]
  }, {
    path: 'moments',
    name: '說說管理',
    iconAws: 'comment-o',
    roles: ['admin', 'visitor', 'editor'],
    children: [
      {
        path: '/momentsListMg',
        name: '說說列表'
      }
    ]
  }, {
    path: 'regardItem',
    name: '心意牆',
    iconAws: 'heart',
    roles: ['admin', 'visitor'],
    children: [
      {
        path: '/regardItem/list',
        name: '贊助方案',
        roles: ['admin']
      },
      {
        path: '/regardItem/sponsors',
        name: '贊助列表',
        roles: ['admin']
      },
      {
        path: '/regardItem/greetings',
        name: '祝福列表',
        roles: ['admin']
      }
    ]
  }, {
    path: 'setting',
    name: '平台管理',
    iconAws: 'cog',
    roles: ['admin', 'visitor', 'editor', 'esg.admin', 'love.admin'],
    children: [
      {
        path: '/cabinetGiftMg',
        name: '好禮公告管理',
        roles: ['admin', 'visitor']
      },
      {
        path: '/bannerMg',
        name: 'Banner管理',
        roles: ['admin', 'visitor', 'editor', 'esg.admin']
      },
      {
        path: '/preEvents',
        name: '預約活動管理',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/stories',
        name: '故事文章管理',
        roles: ['admin', 'visitor', 'editor', 'esg.admin']
      },
      {
        path: '/edmMg',
        name: 'EDM管理',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/notifyMg',
        name: '通知管理',
        roles: ['admin', 'visitor', 'editor', 'love.admin']
      },
      {
        path: '/feedBackMg',
        name: '用戶反饋管理',
        roles: ['admin', 'visitor']
      },
      {
        path: '/changeLogMg',
        name: '更新日志管理',
        roles: ['admin']
      },
      {
        path: '/agreementConfig',
        name: '使用者條款',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/privacyConfig',
        name: '隱私權政策',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/carbonAccountAgreementConfig',
        name: 'GC減碳帳戶使用者條款',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/about543Config',
        name: '認識我們',
        roles: ['admin', 'visitor', 'editor']
      },
      {
        path: '/settings',
        name: '平台設置',
        roles: ['admin']
      },
      {
        path: '/welfare/enterprises',
        name: '社福互動獎-響應企業',
        roles: ['admin']
      }
    ]
  }, {
    path: 'wallet',
    name: '金流管理',
    icon: 'el-icon-money',
    roles: ['visitor'],
    children: [
      {
        path: '/wallet/paymentOrders',
        name: '儲值記錄'
      },
      {
        path: '/wallet/paymentStatistics',
        name: '金額統計'
      },
      {
        path: '/wallet/walletRecords',
        name: '會員錢包記錄'
      },
      {
        path: '/wallet/walletRecordsStatistics',
        name: '蘿蔔點數使用統計'
      },
      {
        path: '/wallet/walletUserStatistics',
        name: '會計月結表'
      },
      {
        path: '/wallet/iboxOrders',
        name: 'i郵箱訂單'
      },
      {
        path: '/wallet/hctOrders',
        name: '月結新竹訂單'
      },
      {
        path: '/wallet/hilifeOrders',
        name: '萊爾富訂單'
      },
      {
        path: '/wallet/sevenElevenOrders',
        name: '7-11訂單'
      },
      {
        path: '/wallet/refunds',
        name: '退點記錄'
      },
      {
        path: '/wallet/coupons',
        name: '抵用券'
      },
      {
        path: '/wallet/couponRecords',
        name: '抵用券記錄'
      }
    ]
  }, {
    path: 'lovebox',
    name: '代贈版',
    iconAws: 'cube',
    roles: ['admin', 'visitor', 'love.admin', 'esg.admin'],
    children: [
      {
        path: '/lovebox/application',
        name: '合作意向管理'
      }, {
        path: '/lovebox/companies-apply',
        name: '申請管理'
      },
      {
        path: '/lovebox/companies',
        name: '共享圈(停用)'
      },
      {
        path: '/lovebox/objects',
        name: '物品管理'
      },
      {
        path: '/lovebox/trades',
        name: '交易管理'
      },
      {
        path: '/lovebox/dispatching',
        name: '愛箱寄送記錄'
      },
      {
        path: '/lovebox/whitelist',
        name: '白名單管理'
      },
      {
        path: '/lovebox/courseNotifyMg',
        name: '教練課通知管理'
      }
    ]
  }, {
    path: 'organization',
    name: 'GC Group',
    iconAws: 'sitemap',
    roles: ['visitor', 'esg.admin'],
    children: [
      {
        path: '/carbonlabelling/organizers',
        name: '聯合團隊'
      },
      {
        path: '/carbonlabelling/groups',
        name: 'Group'
      },
      {
        path: '/carbonlabelling/users',
        name: 'Group成員列表'
      },
      // {
      //   path: '/carbonlabelling/courses',
      //   name: '課程管理'
      // },
      // {
      //   path: '/carbonlabelling/subscriptions',
      //   name: '團隊授權'
      // },
      // {
      //   path: '/carbonlabelling/course-results',
      //   name: '學習數據'
      // },
      {
        path: '/organizers',
        name: '共享圈(停用)'
      },
      {
        path: '/organizers/users',
        name: '共享圈成員列表(停用)'
      },
      {
        path: '/companyPages',
        name: '形象頁(停用)'
      }
    ]
  }, {
    path: 'carbon-account',
    name: 'GC Pro',
    iconAws: 'leaf',
    roles: ['visitor', 'esg.admin'],
    children: [
      {
        path: '/carbon-account/products',
        name: '方案管理'
      },
      {
        path: '/carbon-account/orders',
        name: '訂單管理'
      },
      {
        path: '/carbon-account/discounts',
        name: '折扣碼管理'
      },
      {
        path: '/carbon-account/discount-records',
        name: '折扣碼使用記錄'
      },
      {
        path: '/carbon-account/contacts',
        name: '聯絡'
      }
    ]
  }, {
    path: 'express',
    name: '分享通管理',
    iconAws: 'truck',
    roles: ['visitor'],
    children: [
      {
        path: '/expresses',
        name: '寄件訂單'
      }
    ]
  }
]

export const hasPermission = (roles, nav) => {
  if (nav && nav.roles) {
    return roles.some(role => nav.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}

export default allAsideNav



// WEBPACK FOOTER //
// ./src/router/asideNav.js